<template>
  <div class="page">
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <blue-title>基本信息</blue-title>
      <ApplicationForm :allData="allData"></ApplicationForm>
      <blue-title>必填信息</blue-title>
      <MandatoryInfo :typeList="typeList"></MandatoryInfo>
      <blue-title>选填信息</blue-title>
      <OptionalInfo :typeList="typeList"></OptionalInfo>
    </div>
    <div class="save">
      <el-button type="primary" @click="submit">提交并预览</el-button>
    </div>
  </div>
</template>

<script>
import ApplicationForm from '../../components/addMerchants/applicationFormInfo';
import MandatoryInfo from '../../components/addMerchants/mandatoryInfo';
import OptionalInfo from '../../components/addMerchants/optionalInfo';
import { submit, draftEcho } from '../../../../api/module/merchants';
export default {
  components: {
    ApplicationForm,
    MandatoryInfo,
    OptionalInfo,
  },
  props: {},
  data() {
    return {
      allData: {},
      typeList: [],
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  watch: {},
  created() {
    if (this.uuid !== '') {
      this.draftEcho();
    }
  },
  methods: {
    async draftEcho() {
      const result = await draftEcho({
        uuid: this.uuid,
      });
      this.allData = result;
      if (result.subjectDataVO) {
        this.typeList.push(result.subjectDataVO.type);
      }
      if (result.businessDataVO) {
        this.typeList.push(result.businessDataVO.type);
      }
      if (result.settlementRulesVO) {
        this.typeList.push(result.settlementRulesVO.type);
      }
      if (result.settlementBankAccountVO) {
        this.typeList.push(result.settlementBankAccountVO.type);
      }
      if (result.superAdministratorInformationVO) {
        this.typeList.push(result.superAdministratorInformationVO.type);
      }
      if (result.supplementaryMaterialsVO) {
        this.typeList.push(result.supplementaryMaterialsVO.type);
      }
      console.log(this.typeList);
      console.log('回显所填信息', result);
    },
    async submit() {
      const { uuid, merchantId } = this;
      try {
        await submit({ uuid, merchantId });
        this.$message({
          message: '提交成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/merchants/addMerchants',
            });
          },
        });
      } catch (err) {
        this.$message({
          message: err.msg,
          type: 'warring',
          duration: 1500,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  width: 100%;
  height: 100%;
  background-color: white;
  .save {
    background-color: white;
    box-sizing: border-box;
    padding-left: 31px;
    padding-bottom: 28px;
  }
}
</style>
